import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-632c403a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "" }
const _hoisted_2 = { class: "navbar navbar-expand-lg px-3" }
const _hoisted_3 = { class: "container-fluid p-0 d-flex" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "alternative-text-logo"
}
const _hoisted_8 = {
  class: "collapse navbar-collapse float-end",
  id: "navbarNavDarkDropdown"
}
const _hoisted_9 = { class: "navbar-nav me-auto" }
const _hoisted_10 = { class: "nav-item dropdown" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDarkDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, null, -1))
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDarkDropdownMenuLink"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_15 = {
  class: "dropdown-item",
  ref: "addOrgBtn",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addWorkspaceModal",
  href: "#"
}
const _hoisted_16 = {
  class: "collapse navbar-collapse",
  id: "navbarText"
}
const _hoisted_17 = { class: "navbar-nav me-auto" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 0,
  class: "search-wrapper d-flex align-items-center justify-content-center"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("form", {
  class: "d-flex",
  role: "search"
}, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-control me-2",
    type: "search",
    placeholder: "Search projects, milestones, modules, tasks & actions",
    "aria-label": "Search"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notifications border" }, " 0 new notifications ", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_search_and_user_info = _resolveComponent("search-and-user-info")!
  const _component_AddWorkspaceModal = _resolveComponent("AddWorkspaceModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.logo,
              height: "35"
            }, null, 8, _hoisted_6),
            (!_ctx.logo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.name.slice(0, 2).toUpperCase()), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("ul", _hoisted_12, [
                    _createElementVNode("li", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspaces, (org) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item",
                          href: "#",
                          key: org.workspaceId,
                          onClick: ($event: any) => (_ctx.selectWorkspace(org))
                        }, _toDisplayString(org.name), 9, _hoisted_13))
                      }), 128))
                    ]),
                    _hoisted_14,
                    _createElementVNode("li", null, [
                      _createElementVNode("a", _hoisted_15, "Add Workspace", 512)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("ul", _hoisted_17, [
              _createElementVNode("li", _hoisted_18, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["nav-link", { 'router-link-exact-active': _ctx.highlightBlueprint }]),
                  to: { name: 'settings-processes' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Blueprints")
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("li", _hoisted_19, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(["nav-link", { 'router-link-exact-active': _ctx.highlightExecution }]),
                  to: { name: 'projects' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Executions")
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("li", _hoisted_20, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: { name: 'settings' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Settings")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_21, [
                (_ctx.customerPortalLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "nav-link ps-4",
                      href: _ctx.customerPortalLink
                    }, [
                      _createVNode(_component_feather_icon, {
                        type: "external-link",
                        class: "cursor-pointer position-absolute extern-link",
                        size: "15"
                      }),
                      _createTextVNode(" Work Portal ")
                    ], 8, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
          : _createCommentVNode("", true),
        _createVNode(_component_search_and_user_info)
      ]),
      _createVNode(_component_AddWorkspaceModal)
    ])
  ]))
}